import { action } from 'satcheljs/lib/legacy';
export default action('updateRecipientWellDirty')(function updateRecipientWellDirty(recipientWell, isDirty) {
    recipientWell.isDirty = isDirty;
});
//# sourceMappingURL=updateRecipientWellDirty.js.map